import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"label":_vm.$t('Operator'),"outlined":"","items":_vm.textOperators,"hide-details":""},model:{value:(_vm.operator),callback:function ($$v) {_vm.operator=$$v},expression:"operator"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }